export default __webpack_public_path__ + "static/media/optionsDropDownIcon.39e082d0.svg";